import React from 'react';
import { Play } from 'lucide-react';
import { cn } from '../../lib/utils';
interface PlayButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}
export function PlayButton({
  className,
  ...props
}: PlayButtonProps) {
  return <button className={cn('group relative w-full h-24 rounded-3xl bg-gradient-to-b from-blue-400 to-blue-600 shadow-[0_8px_0_rgb(29,78,216)] active:shadow-none active:translate-y-2 transition-all duration-150 flex items-center justify-center overflow-hidden', className)} {...props} data-id="element-187">
      <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-188" />
      <div className="flex items-center gap-4 text-white" data-id="element-189">
        <div className="p-3 bg-white/20 rounded-full backdrop-blur-sm" data-id="element-190">
          <Play fill="currentColor" size={32} data-id="element-191" />
        </div>
        <span className="text-3xl font-black tracking-wider drop-shadow-md" data-id="element-192">
          PLAY
        </span>
      </div>
    </button>;
}